<template>
  <div id="candle-show">
    <b-col>
      <h1 class="title">{{ $t('notification.all') }}</h1>
    </b-col>
    <e-index
      :uri="getUri()"
      :can-create="false"
      name="notification"
      mode="list"
    >
      <div slot="list-content" slot-scope="ctx">
        <one-notification :notification="ctx.item" />
      </div>
    </e-index>
  </div>
</template>

<script>
  import EIndex from '@/components/EIndex';
  import OneNotification from '@/components/OneNotification';

  export default {
    name: 'Notifications',
    components: {
      EIndex,
      OneNotification,
    },
    methods: {
      getUri() {
        return `api/memorial/${this.user().memorial.id}/notification/`;
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '~@/scss/vars';

  /deep/ .list-group-item {
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/Default/Notifications.vue